module.exports = __webpack_public_path__ + "img/img4.53eb6f0a.png";